import classNames from 'classnames';
import React, { useCallback } from 'react';

import { Accordion } from '@sravni/react-design-system';
import type { AccordionItemProps } from '@sravni/react-design-system/dist/types/components/Accordion/types/Accordion.types';
import { useBoolean } from '@sravni/react-utils';

import styles from './styles.module.scss';

export const AccordionItem: React.FC<React.ComponentProps<typeof Accordion.Item>> = ({
  className,
  title,
  ...props
}) => {
  const [collapsed, toggleCollapsed] = useBoolean(false);

  const onChange = useCallback<AccordionItemProps['onChange']>(
    (isExpandState) => {
      toggleCollapsed[!isExpandState ? 'on' : 'off']();
    },
    [toggleCollapsed],
  );

  return (
    <Accordion.Item
      {...props}
      title={
        <span className={styles['accordion-item-title']}>
          {title}
          <div
            className={classNames(
              styles['accordion-item-icon'],
              !collapsed && styles['accordion-item-icon--collapsed'],
            )}
          />
        </span>
      }
      className={classNames(className, styles['accordion-item'])}
      onChange={onChange}
    />
  );
};
